import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=2a9be7e6&scoped=true&"
import script from "./Push.vue?vue&type=script&lang=js&"
export * from "./Push.vue?vue&type=script&lang=js&"
import style0 from "./Push.vue?vue&type=style&index=0&id=2a9be7e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9be7e6",
  null
  
)

export default component.exports